var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 28,
    viewBox: "0 0 18 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2580",
    "data-name": "Group 2580",
    transform: "translate(-614.5 -550.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1313",
    "data-name": "Rectangle 1313",
    transform: "translate(614.5 578.93) rotate(-90)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 18,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 17,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2300",
    "data-name": "Group 2300",
    transform: "translate(198.439 -28.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M901.814,286.091a3.272,3.272,0,0,1-1.159.345v-6.413a2.87,2.87,0,0,1,1.082.345,2.9,2.9,0,0,1,.814.689l1.129-1.072a4.685,4.685,0,0,0-1.3-1,4.186,4.186,0,0,0-1.723-.449v-1.7h-1.167v1.723a4.562,4.562,0,0,0-1.6.546,4.5,4.5,0,0,0-1.234,1.033,4.7,4.7,0,0,0-.8,1.426,5,5,0,0,0-.286,1.685,5.5,5.5,0,0,0,.268,1.732,4.323,4.323,0,0,0,.776,1.426,4.264,4.264,0,0,0,1.234,1.014,4.537,4.537,0,0,0,1.648.517v1.684h1.167v-1.648a4.5,4.5,0,0,0,3.063-1.473l-1.053-1.11A2.627,2.627,0,0,1,901.814,286.091Zm-2.326.268a2.4,2.4,0,0,1-.919-.459,3.285,3.285,0,0,1-.68-.747,3.585,3.585,0,0,1-.431-.918,3.354,3.354,0,0,1-.153-1,3.739,3.739,0,0,1,.143-1.033,3.2,3.2,0,0,1,.431-.92,3.157,3.157,0,0,1,.689-.728,2.566,2.566,0,0,1,.919-.44Z",
    transform: "translate(-474.835 311.283)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMoney);
export default __webpack_public_path__ + "static/media/mobile-money.1ff65188c640e1dc4a6aa090f76dcafd.svg";
export { ForwardRef as ReactComponent };